<template>
  <div class="hisdata">
    <el-row>
      <el-form :inline="true" :model="formModel" :rules="rules" ref="form">
        <el-form-item :label="'选择时间:' | translateTo('query')" prop="date">
          <el-date-picker
            prop="date"
            v-model="formModel.date"
            type="datetimerange"
            value-format="timestamp"
            :range-separator="$t('至')"
            :start-placeholder="$t('开始日期')"
            :end-placeholder="$t('结束日期')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" :loading="loading">
            {{ $t('查询') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20" class="hisdata-content">
      <el-col :span="8">
        <div class="bm-item">
          <div class="bm-title">{{ $t('生物气溶胶时间曲线') }}</div>
          <div class="bm-line">
            <Bm4000Line :op="lineOp_1" />
          </div>
        </div>
        <div class="bm-item">
          <div class="bm-title">{{ $t('气溶胶粒子总数时间曲线') }}</div>
          <div class="bm-line">
            <Bm4000Line :op="lineOp_2" />
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="bm-title">{{ $t('历史数据列表') }}</div>
        <div class="table-box" v-loading="loading" element-loading-background="#0c1620">
          <el-table
            v-if="tableData.length > 0"
            ref="tableRef"
            height="calc(100% - 80px)"
            :data="curPageData"
          >
            <el-table-column fixed type="expand">
              <template slot-scope="{ row }">
                <item :source="row" :sn="sn"></item>
              </template>
            </el-table-column>
            <template v-for="(e, i) in theadEn">
              <el-table-column
                :fixed="i === 0"
                :key="e"
                :prop="e"
                :label="theadZh[i]"
                :width="i === 0 ? '160px' : '120px'"
              ></el-table-column>
            </template>
          </el-table>
          <el-pagination
            v-if="tableData.length > 0"
            class="fixed-bottom"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="paginationCfg.offset"
            :page-sizes="paginationCfg.limits"
            :page-size.sync="paginationCfg.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationCfg.total"
          ></el-pagination>
          <div v-else class="no-data">{{ $t('暂无数据') }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryOrdata } from '@/api/stat';
import { formatTimestamp } from '@/utils/utils';
import Bm4000Line from '@/views/realdata/BM4000/components/bm4000-line';
import Item from './component/item';

export default {
  components: {
    Bm4000Line,
    Item
  },
  props: {
    sn: String
  },
  data() {
    return {
      busiType: 2,
      loading: false,
      formModel: {
        date: [Date.now() - 36e5, Date.now()]
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }]
      },
      lineOp_1: {
        color: ['#5b87ff', '#7b6af1', '#f878f8'],
        yAxis: {
          name: '个升'
        },
        series: [
          {
            encode: { x: 'timestamp', y: 'bioEffectiveBground', seriesName: 'bioEffectiveBground' }
          },
          { encode: { x: 'timestamp', y: 'bioEffectiveBioall', seriesName: 'bioEffectiveBioall' } },
          {
            encode: {
              x: 'timestamp',
              y: 'bioEffectiveConcentration',
              seriesName: 'bioEffectiveConcentration'
            }
          }
        ],
        dataset: {
          dimensions: [
            { name: 'time', type: 'time' },
            { name: 'bioEffectiveBground', displayName: '气溶胶荧光背景' },
            { name: 'bioEffectiveBioall', displayName: '荧光粒子总数' },
            { name: 'bioEffectiveConcentration', displayName: '生物粒子浓度' }
          ],
          source: []
        }
      },
      lineOp_2: {
        color: ['#f16aec', '#7b6af1'],
        yAxis: {
          name: '个升'
        },
        series: [
          { encode: { x: 'timestamp', y: 'bio2ParAll', seriesName: 'bio2ParAll' } },
          { encode: { x: 'timestamp', y: 'bio2NoiseBground', seriesName: 'bio2NoiseBground' } }
        ],
        dataset: {
          dimensions: [
            { name: 'time', type: 'time' },
            { name: 'bio2ParAll', displayName: '气溶胶粒子总数' },
            { name: 'bio2NoiseBground', displayName: '噪声本底' }
          ],
          source: []
        }
      },
      theadEn: [],
      theadZh: [],
      tableData: [],
      paginationCfg: {
        offset: 1,
        limit: 10,
        limits: [10, 50, 100, 200],
        total: 0
      }
    };
  },
  computed: {
    curPageData() {
      // 本地分页
      const { offset, limit } = this.paginationCfg;
      const realOffset = (offset - 1) * limit;
      return this.tableData.slice(realOffset, realOffset + limit);
    }
  },
  methods: {
    langChangeHandler() {
      this.lineOp_1.yAxis.name = this.translateTo(this.lineOp_1.yAxis.name, 'device');
      ['time', '气溶胶荧光背景', '荧光粒子总数', '生物粒子浓度'].forEach((item, i) => {
        this.lineOp_1.dataset.dimensions[i].displayName = this.translateTo(item, 'device');
      });

      this.lineOp_2.yAxis.name = this.translateTo(this.lineOp_2.yAxis.name, 'device');
      ['time', '气溶胶粒子总数', '噪声本底'].forEach((item, i) => {
        this.lineOp_2.dataset.dimensions[i].displayName = this.translateTo(item, 'device');
      });

      this.search();
    },
    formatTimestamp,
    search() {
      this.$refs['form'].validate(v => {
        if (v) {
          this.loading = true;
          const { offset, limit } = this.paginationCfg;
          queryOrdata({
            sn: this.sn,
            beginTime: this.formModel.date[0],
            endTime: this.formModel.date[1],
            busiType: this.busiType,
            dataScale: 1,
            offset,
            limit
          })
            .then(res => {
              this.tableData =
                this.lineOp_1.dataset.source =
                this.lineOp_2.dataset.source =
                  res.data.pageData;
              this.theadZh = res.data.dimensionsZh;
              this.theadEn = res.data.dimensions;
              this.paginationCfg.total = res.data.pageData.length;

              this.$nextTick(() => {
                this.$refs.tableRef?.doLayout();
              });
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    handleSizeChange() {
      // this.search();
    },
    handleCurrentChange() {
      // this.search();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.langChangeHandler();
    });
  }
};
</script>

<style lang="scss">
.hisdata {
  height: 100%;
  .bm-title {
    height: 60px;
    line-height: 60px;
    font-size: 22px;
    font-weight: bold;
    color: $normal-color;
  }
  .hisdata-content {
    height: calc(100% - 80px);
    > .el-col {
      height: 100%;
    }
    .bm-item {
      height: 50%;
      .bm-line {
        height: calc(100% - 60px);
        border-radius: 10px;
        overflow: hidden;
      }
    }
    .table-box {
      box-sizing: border-box;
      height: calc(100% - 60px);
      border-radius: 10px;
      padding: 10px;
      background-color: #121e2c;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      .item,
      .title {
        display: flex;
        color: $normal-color;
        border-left: 1px solid #1c3755;
        span {
          box-sizing: border-box;
          display: inline-block;
          border-right: 1px solid #1c3755;
          border-bottom: 1px solid #1c3755;
          height: 60px;
          padding: 5px;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          flex: 1;
          &:first-child {
            flex: 0.5;
          }
          &:nth-child(2) {
            flex: 3;
          }
        }
      }
      .title {
        span {
          border-top: 1px solid #1c3755;
        }
      }
      .virtual-list {
        height: calc(100% - 60px);
        overflow-y: auto;
        @include scrollar-style-bold;
      }
      .no-data {
        @include flex-center;
        height: 60px;
        color: $normal-color;
      }
      .bm-bar {
        height: 300px;
        padding: 10px;
      }
    }
    .table-item {
      .el-row {
        position: sticky;
        left: 40px;
        width: 1000px;
      }
    }
    .fixed-bottom {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
